module.exports = __webpack_public_path__ + "static/leaves-b9d6b7741714dcdf886e4e1af1ad19aa.png";